import { render, staticRenderFns } from "./Purchase_kanban.vue?vue&type=template&id=b8cc2db0"
import script from "./Purchase_kanban.vue?vue&type=script&lang=js"
export * from "./Purchase_kanban.vue?vue&type=script&lang=js"
import style0 from "./Purchase_kanban.vue?vue&type=style&index=0&id=b8cc2db0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports